import { createSignal, DEV, splitProps } from "solid-js";
import { Select } from "~/components/Forms/Fields/Base/Select";

import type {
  InputOption,
  SelectProps,
  ValidationFunc,
} from "~/components/Forms/Fields/Base/InputTypesProps";
import { picklist, safeParse } from "valibot";
import ValidationErrors from "./Base/ValidationErrors";
import IconEvent from "~/img/icons/push/event.svg";

const LABEL = "Date de l'évènement";
const HELP = undefined;
const IS_REQUIRED_BY_DEFAULT = false;

export function DateSelectSchema(availableOptions: InputOption[]) {
  return {
    hour: picklist(
      availableOptions.map((o) => o.value),
      "Veuillez sélectionner une date.",
    ),
  };
}

export function DateSelect(props: SelectProps) {
  const [local, others] = splitProps(props, [
    "label",
    "help",
    "required",
    "options",
  ]);
  const [validationErrors, setValidationErrors] = createSignal<string[]>([]);

  const validate: ValidationFunc = (input) => {
    const ret = safeParse(DateSelectSchema(props.options).hour, input);
    ret.success
      ? setValidationErrors([])
      : setValidationErrors(ret.issues.map((issue) => issue.message));
  };

  DEV && console.log("local.options", local.options);

  return (
    <>
      <div class={`form-item-${props.name}`}>
        <Select
          label={local.label || LABEL}
          help={local.help || HELP}
          validateFn={validate}
          required={
            local.required !== undefined
              ? local.required
              : IS_REQUIRED_BY_DEFAULT
          }
          options={local.options}
          prependIcon={<IconEvent />}
          {...others}
        />
        <ValidationErrors
          errors={validationErrors()}
          field={props.name}
          withPrependIcon
        />
      </div>
    </>
  );
}
